import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import pmmService from '../services/paymentMigrationManagerService';
import OhipLovPicker from './OhipAgentTypePicker';
import './AddCorporateProfilePage.css';

const ROUTING_TYPES = [
    { value: 'Window Routing', label: 'Window Routing' },
    { value: 'Room Routing',   label: 'Room Routing' },
];

const WINDOWS = ['1', '2', '3', '4', '5', '6', '7', '8'];

const PMMAddRoutingCodePage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [form, setForm] = useState({ code: '', routing_type: 'Window Routing', description: '', default_window: '1' });
    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);

    const set = (field, value) => {
        setForm(f => ({ ...f, [field]: value }));
        setErrors(e => ({ ...e, [field]: undefined }));
    };

    const validate = () => {
        const e = {};
        if (!form.code.trim()) e.code = 'Code is required';
        if (!form.description.trim()) e.description = 'Description is required';
        return e;
    };

    const handleCreate = async () => {
        const e = validate();
        if (Object.keys(e).length) { setErrors(e); return; }
        setSaving(true);
        try {
            await pmmService.createRoutingCode(id, {
                code:           form.code.trim(),
                routing_type:   form.routing_type || null,
                description:    form.description || null,
                default_window: form.default_window || null,
            });
            navigate(`/apps/payment-migration-manager/${id}`);
        } catch (err) {
            setErrors({ submit: err.response?.data?.error?.message || 'Failed to save routing code' });
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="acp-page">
            <div className="acp-card">
                <div className="acp-card-header">
                    <h1 className="acp-title">Add Routing Code</h1>
                    <p className="acp-subtitle">Add a routing code to the library for use in this migration</p>
                </div>
                <div className="acp-divider" />
                <div className="acp-body">
                    <div className="acp-row-2">
                        <div className="acp-field">
                            <label className="acp-label">Code <span className="acp-required">*</span></label>
                            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start' }}>
                                <input className={`acp-input${errors.code ? ' acp-input-error' : ''}`} type="text" placeholder="Enter routing code" value={form.code} onChange={e => set('code', e.target.value)} autoFocus />
                                <OhipLovPicker
                                    fetchFn={() => pmmService.getOhipRoutingCodes(id)}
                                    title="Select Routing Code from Opera Cloud"
                                    emptyMsg="No routing codes returned from Opera Cloud."
                                    onSelectItem={({ code, description }) => {
                                        set('code', code);
                                        if (description && description !== code) set('description', description);
                                    }}
                                />
                            </div>
                            {errors.code && <span className="acp-error-msg">{errors.code}</span>}
                        </div>
                        <div className="acp-field">
                            <label className="acp-label">Routing Type</label>
                            <select className="acp-select" value={form.routing_type} onChange={e => set('routing_type', e.target.value)}>
                                {ROUTING_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="acp-row-2">
                        <div className="acp-field">
                            <label className="acp-label">Default Window</label>
                            <select className="acp-select" value={form.default_window} onChange={e => set('default_window', e.target.value)}>
                                {WINDOWS.map(w => <option key={w} value={w}>{w}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="acp-field">
                        <label className="acp-label">Description <span className="acp-required">*</span></label>
                        <textarea className={`acp-input${errors.description ? ' acp-input-error' : ''}`} rows={4} placeholder="Describe the routing code and its purpose" value={form.description} onChange={e => set('description', e.target.value)} style={{ resize: 'vertical' }} />
                        {errors.description && <span className="acp-error-msg">{errors.description}</span>}
                    </div>
                </div>
                {errors.submit && <div className="acp-error-msg" style={{ margin: '0 0 1rem' }}>{errors.submit}</div>}
                <div className="acp-footer">
                    <button className="acp-btn-cancel" onClick={() => navigate(`/apps/payment-migration-manager/${id}`)} disabled={saving}>Cancel</button>
                    <button className="acp-btn-create" onClick={handleCreate} disabled={saving}>{saving ? 'Creating...' : 'Create'}</button>
                </div>
            </div>
        </div>
    );
};

export default PMMAddRoutingCodePage;
